"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Updates cart reviews v2 totals for a given query key
 *
 * @param {object} params - named parameters
 * @param {object} params.queryClient - the query client
 * @param {function} params.getQueryKey - function that returns the query key
 * @param {number} params.summaryTotal - total amount
 * @param {number} params.summarySubtotal - subtotal amount
 * @param {number} params.summaryDiscountTotal - discount total
 */
var updateCartReviewsV2 = function updateCartReviewsV2(_ref) {
  var queryClient = _ref.queryClient,
    getQueryKey = _ref.getQueryKey,
    summaryTotal = _ref.summaryTotal,
    summarySubtotal = _ref.summarySubtotal,
    summaryDiscountTotal = _ref.summaryDiscountTotal;
  var isCartEmpty = summaryTotal === 0 && summarySubtotal === 0;
  queryClient.setQueryData(getQueryKey(), function (cartReviews) {
    var _cartReviews$response, _totals$items;
    var totals = (cartReviews === null || cartReviews === void 0 || (_cartReviews$response = cartReviews.response) === null || _cartReviews$response === void 0 ? void 0 : _cartReviews$response.totals) || {};
    return _objectSpread(_objectSpread({}, cartReviews), {}, {
      response: _objectSpread(_objectSpread({}, cartReviews === null || cartReviews === void 0 ? void 0 : cartReviews.response), {}, {
        totals: _objectSpread(_objectSpread(_objectSpread({}, totals), {}, {
          total: summaryTotal
        }, isCartEmpty && {
          fulfillment: _objectSpread(_objectSpread({}, totals === null || totals === void 0 ? void 0 : totals.fulfillment), {}, {
            total: 0
          }),
          taxes: _objectSpread(_objectSpread({}, totals === null || totals === void 0 ? void 0 : totals.taxes), {}, {
            total: 0
          })
        }), {}, {
          items: _objectSpread(_objectSpread({}, totals === null || totals === void 0 ? void 0 : totals.items), {}, {
            details: _objectSpread(_objectSpread({}, totals === null || totals === void 0 || (_totals$items = totals.items) === null || _totals$items === void 0 ? void 0 : _totals$items.details), {}, {
              price: summarySubtotal,
              discount: summaryDiscountTotal
            })
          })
        })
      })
    });
  });
};
var _default = exports["default"] = updateCartReviewsV2;